import { useState } from 'react'
import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem
} from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck, faCircleXmark } from '@fortawesome/free-solid-svg-icons'
import FocProductRequirement from './Forms/FormComponents/FocComponents/FocProductRequirement'
import FocEnquiryDetails from './Forms/FormComponents/FocComponents/FocEnquiryDetails'
import FocMarketingPlatform from './Forms/FormComponents/FocComponents/FocMarketingPlatform'
import FocWorkingPlatform from './Forms/FormComponents/FocComponents/FocWorkingPlatform'
import FocBuyingPlatform from './Forms/FormComponents/FocComponents/FocBuyingPlatform'
import FocReachedAgreement from './Forms/FormComponents/FocComponents/FocReachedAgreement'
import FocLineItems from './FocLineItems'

const FocStagesAccordion = ({ focLeadDetails, leadId, openAccordion, setOpenAccordion, onDataUpdate, saveAllRefs }) => {
    const toggleAccordion = (id) => {
        setOpenAccordion(openAccordion === id ? '' : id)
    }

    // Helper function to check if a specific item is complete
    const isItemComplete = (status) => {
        return status !== 'pending' && status !== null
    }

    return (
        <Accordion open={openAccordion} toggle={toggleAccordion}>
            {/* Accordion 1: Line Items */}
            <AccordionItem>
                <AccordionHeader targetId="1">
                    <div className="d-flex align-items-center w-100">
                        {isItemComplete(focLeadDetails?.buyingPlatform?.status) ? (
                            <FontAwesomeIcon
                                className='text-success me-3'
                                icon={faCircleCheck}
                                size="lg"
                            />
                        ) : (
                            <FontAwesomeIcon
                                className='text-danger me-3'
                                icon={faCircleXmark}
                                size="lg"
                            />
                        )}
                        <div>
                            <strong>Line Items</strong>
                            <div className="text-muted small">
                                Add FOC products
                            </div>
                        </div>
                    </div>
                </AccordionHeader>
                <AccordionBody accordionId="1">
                    <FocLineItems focLeadId={leadId} focLeadDetails={focLeadDetails} onDataUpdate={onDataUpdate} />
                </AccordionBody>
            </AccordionItem>

            {/* Accordion 2: Product Requirement */}
            <AccordionItem>
                <AccordionHeader targetId="2">
                    <div className="d-flex align-items-center w-100">
                        {isItemComplete(focLeadDetails?.productRequirements?.status) ? (
                            <FontAwesomeIcon
                                className='text-success me-3'
                                icon={faCircleCheck}
                                size="lg"
                            />
                        ) : (
                            <FontAwesomeIcon
                                className='text-danger me-3'
                                icon={faCircleXmark}
                                size="lg"
                            />
                        )}
                        <div>
                            <strong>Product Requirement</strong>
                            <div className="text-muted small">
                                Define product specifications
                            </div>
                        </div>
                    </div>
                </AccordionHeader>
                <AccordionBody accordionId="2">
                    <div className="p-3">
                        <FocProductRequirement ref={saveAllRefs?.productRequirementRef} id={leadId} onDataUpdate={onDataUpdate} focLeadDetails={focLeadDetails} />
                    </div>
                </AccordionBody>
            </AccordionItem>

            {/* Accordion 3: Enquiry Details */}
            <AccordionItem>
                <AccordionHeader targetId="3">
                    <div className="d-flex align-items-center w-100">
                        {isItemComplete(focLeadDetails?.enquiryDetails?.status) ? (
                            <FontAwesomeIcon
                                className='text-success me-3'
                                icon={faCircleCheck}
                                size="lg"
                            />
                        ) : (
                            <FontAwesomeIcon
                                className='text-danger me-3'
                                icon={faCircleXmark}
                                size="lg"
                            />
                        )}
                        <div>
                            <strong>Enquiry Details</strong>
                            <div className="text-muted small">
                                Capture enquiry information
                            </div>
                        </div>
                    </div>
                </AccordionHeader>
                <AccordionBody accordionId="3">
                    <div className="p-3">
                        <FocEnquiryDetails ref={saveAllRefs?.enquiryDetailsRef} id={leadId} onDataUpdate={onDataUpdate} focLeadDetails={focLeadDetails} />
                    </div>
                </AccordionBody>
            </AccordionItem>

            {/* Accordion 4: Marketing Platform */}
            <AccordionItem>
                <AccordionHeader targetId="4">
                    <div className="d-flex align-items-center w-100">
                        {isItemComplete(focLeadDetails?.marketingPlatform?.status) ? (
                            <FontAwesomeIcon
                                className='text-success me-3'
                                icon={faCircleCheck}
                                size="lg"
                            />
                        ) : (
                            <FontAwesomeIcon
                                className='text-danger me-3'
                                icon={faCircleXmark}
                                size="lg"
                            />
                        )}
                        <div>
                            <strong>Marketing Platform</strong>
                            <div className="text-muted small">
                                Update marketing platform details
                            </div>
                        </div>
                    </div>
                </AccordionHeader>
                <AccordionBody accordionId="4">
                    <div className="p-3">
                        <FocMarketingPlatform ref={saveAllRefs?.marketingPlatformRef} id={leadId} onDataUpdate={onDataUpdate} focLeadDetails={focLeadDetails} />
                    </div>
                </AccordionBody>
            </AccordionItem>

            {/* Accordion 5: Working Platform */}
            <AccordionItem>
                <AccordionHeader targetId="5">
                    <div className="d-flex align-items-center w-100">
                        {isItemComplete(focLeadDetails?.workingPlatform?.status) ? (
                            <FontAwesomeIcon
                                className='text-success me-3'
                                icon={faCircleCheck}
                                size="lg"
                            />
                        ) : (
                            <FontAwesomeIcon
                                className='text-danger me-3'
                                icon={faCircleXmark}
                                size="lg"
                            />
                        )}
                        <div>
                            <strong>Working Platform</strong>
                            <div className="text-muted small">
                                Update working platform details
                            </div>
                        </div>
                    </div>
                </AccordionHeader>
                <AccordionBody accordionId="5">
                    <div className="p-3">
                        <FocWorkingPlatform ref={saveAllRefs?.workingPlatformRef} id={leadId} onDataUpdate={onDataUpdate} focLeadDetails={focLeadDetails} />
                    </div>
                </AccordionBody>
            </AccordionItem>

            {/* Accordion 6: Buying Platform */}
            <AccordionItem>
                <AccordionHeader targetId="6">
                    <div className="d-flex align-items-center w-100">
                        {isItemComplete(focLeadDetails?.buyingPlatform?.status) ? (
                            <FontAwesomeIcon
                                className='text-success me-3'
                                icon={faCircleCheck}
                                size="lg"
                            />
                        ) : (
                            <FontAwesomeIcon
                                className='text-danger me-3'
                                icon={faCircleXmark}
                                size="lg"
                            />
                        )}
                        <div>
                            <strong>Buying Platform</strong>
                            <div className="text-muted small">
                                Update buying platform details
                            </div>
                        </div>
                    </div>
                </AccordionHeader>
                <AccordionBody accordionId="6">
                    <div className="p-3">
                        <FocBuyingPlatform ref={saveAllRefs?.buyingPlatformRef} id={leadId} onDataUpdate={onDataUpdate} focLeadDetails={focLeadDetails} />
                    </div>
                </AccordionBody>
            </AccordionItem>

            {/* Accordion 7: Sales Order / Agreement */}
            <AccordionItem>
                <AccordionHeader targetId="7">
                    <div className="d-flex align-items-center w-100">
                        {focLeadDetails?.agreement?.stage === 'won' ? (
                            <FontAwesomeIcon
                                className='text-success me-3'
                                icon={faCircleCheck}
                                size="lg"
                            />
                        ) : (
                            <FontAwesomeIcon
                                className='text-warning me-3'
                                icon={faCircleXmark}
                                size="lg"
                            />
                        )}
                        <div>
                            <strong>Sales Order / Agreement</strong>
                            <div className="text-muted small">
                                FOC Sales Order Agreement
                            </div>
                        </div>
                    </div>
                </AccordionHeader>
                <AccordionBody accordionId="7">
                    <div className="p-4">
                        <h5 className='mb-3'>FOC Sales Order Agreement</h5>
                        <FocReachedAgreement id={leadId} onDataUpdate={onDataUpdate} focLeadDetails={focLeadDetails} />
                    </div>
                </AccordionBody>
            </AccordionItem>
        </Accordion>
    )
}

export default FocStagesAccordion
